// extracted by mini-css-extract-plugin
export default {"login_btn":"Login_login_btn__+cVAA","login_btn_box":"Login_login_btn_box__L1gXs"};